export const DashboardRoutes = {
  INDEX: "/",
} as const;
